import React from 'react'

import { useChecklist } from './_load/ChecklistLoader'
import { useCloneChecklist } from './_request/cloneChecklist'
import { useModalData } from '../../../components/modals/ModalsContext'
import Form from '../../../packages/kiti/components/form/form/Form'
import GeneralSection from './sections/GeneralSection'
import SubmitBar from '../../../packages/kiti/components/form/SubmitBar'

const CloneForm = () => {
  const { fromTemplates, toTemplates } = useModalData()
  const checklist = useChecklist()
  const [onSubmit, { loading, error }] = useCloneChecklist()

  return (
    <Form loading={loading} onSubmit={onSubmit} initialState={{ ...checklist, fromTemplates, toTemplates }}>
      <GeneralSection />
      <SubmitBar loading={loading} error={error} label="Clonar" />
    </Form>
  )
}

export default CloneForm
